'use client';
import Link from 'next/link';

import type { Media, Post } from '@/payload-types';

import { MediaComponent } from '@/components/Media';
import React, { FC } from 'react';
import { pseudoI18n } from '@/i18n/pseudoI18n';
import { ChevronRight, Clock9 } from 'lucide-react';
import { PATHS } from '@/constants/paths';

export const ArticleCard: FC<{
  doc?: Post;
}> = props => {
  const { doc } = props;

  const { slug, meta, title, createdAt } = doc || {};
  const { description, image: metaImage } = meta || {};

  const { t } = pseudoI18n();

  const sanitizedDescription = description?.replace(/\s/g, ' '); // replace non-breaking space with white space
  const href = `${PATHS.POSTS}/${slug}`;

  const createdDate = createdAt ? new Date(createdAt).toLocaleDateString('vi-VN') : '';

  return (
    <Link href={href} className='rounded-xl'>
      <article className="relative flex flex-col h-full">
        <MediaComponent
          resource={{ ...(metaImage as Media), height: 288 }}
          imgClassName="h-32 sm:h-64 md:h-80 lg:h-72 object-contain rounded-xl border border-neutral-300"
        />
        <p className="mt-3 font-semibold line-clamp-2 sm:line-clamp-3">{title}</p>
        {description && (
          <div className="mt-1 mb-4">
            <p className="line-clamp-3 text-sm sm:line-clamp-2">{sanitizedDescription}</p>
          </div>
        )}
        <div className="mt-auto text-sm font-bold flex flex-col sm:flex-row sm:justify-between sm:items-center">
          <p className="text-neutral-500 flex items-center">
            <Clock9 width={16} height={16} className="mr-2" />
            {createdDate}
          </p>
          <p className="absolute inset-0 sm:static w-full sm:w-auto opacity-0 sm:opacity-100 flex items-center text-secondary">
            {t('Read the post')}
            <ChevronRight width={16} height={16} className="ml-2" />
          </p>
        </div>
      </article>
    </Link>

  );
};
